import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';

export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  async created() {
    await Promise.all([this.$store.dispatch('finish/getItems'), this.$store.dispatch('finish/getItems')]);
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'TemplateImage',
    returnTo: 'TemplateImages'
  }),
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
